import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import {
    ProgressBar as ProgressBarBs,
    ProgressBarProps as ProgressBarPropsBs
} from '@bootstrap-styled/v4'
import { omit } from 'ramda'
import Color from '@bootstrap-styled/color'

//type definition
export type ProgressBarProps = {
    color?: ProgressBarPropsBs['color'] | 'active' | 'pending' | 'givens'
} & Omit<ProgressBarPropsBs, 'color' | 'as' | 'property'>

const ProgressBar = styled(
    (attrs: ProgressBarProps): JSX.Element => (
        <ProgressBarBs {...omit(['color', 'pendingColor'], attrs)} />
    )
).attrs(props => ({
    className: classNames(props.className, {
        [`bg-${props.color}`]: !!props.color
    }),
    pendingColor: Color(props.theme['$primary'])
        .lightness(60)
        .string()
}))`
    /* Custom colors */
    &.bg-active {
        background-color: ${props => props.theme['$teal']};
    }

    &.bg-pending {
        background-color: ${props => props.pendingColor};
    }

    &.bg-givens {
        background-color: ${props => props.theme['$opal']};
    }
`
export default ProgressBar
